import {
  MESSAGE_LOADER_GETTERS_ENUM,
} from './message-loader.eum';

export const messageLoaderGetters = {
  [MESSAGE_LOADER_GETTERS_ENUM.GET_LOADING_MESSAGE](state) {
    return state.loadingMessage;
  },
};
